module.exports = __webpack_public_path__ + "static/media/home-image-icon.af94e119.png";